import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { Ge as $, hi as E, di as z, M as U } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as j } from "./state-b4c9cc73-ee633f6c.js";
import { i as A } from "./query-24926cff-3eb94bfb.js";
import { Ra as B, _t as I, St as Z } from "./chart-base-ecca78b9-a6ec3103.js";
import "./breakpoints-1ea07f11-d0da757c.js";
import "./chart-base.helpers-722f3948-fa82acec.js";
import "./unsafe-svg-8b07bc77-f986d223.js";
import "./utils-2e24a437-383bbd0f.js";
import "./variables-37cba309-153935bd.js";
import "./map-7910a3a7-389c4b7b.js";
import "./chart-tooltip-e4995844-42c7681e.js";
import "./legend-5216905c-c7014324.js";
import "./legend-circle-0e9cbc84-7a23b644.js";
import "./directive-daf4e9b6-abc0af54.js";
var g = /* @__PURE__ */function (h) {
    return h.GROUP = "groupPadding", h.POINT = "pointPadding", h;
  }(g || {}),
  N = /* @__PURE__ */function (h) {
    return h.NORMAL = "normal", h.PERCENT = "percent", h;
  }(N || {});
var c = {
    beaconTagName: "beacon-bar-chart",
    stackingAttribute: "stacking",
    tooltipID: "chart-custom-tooltip"
  },
  _ = 5,
  R = 0.2,
  W = 0.1,
  f = {
    small: 531,
    medium: 795,
    large: 1051
  },
  u = {
    small: {
      end: 3,
      max: 468
    },
    medium: {
      end: 6,
      max: 768,
      start: 4
    },
    large: {
      max: 980,
      start: 7
    },
    xLarge: {
      max: 1024
    }
  },
  s = [0.16, 0.16, 0.16],
  p = [0.128, 0.128, 0.128],
  x = [0.064, 0.064, 0.064],
  q = [0.064, 0.064, 0],
  F = 3 * 4 + 48,
  J = 2 * 4 + 36,
  K = 6 + 32,
  Q = 3 * 4 + 32,
  Y = 2 * 4 + 24,
  X = 4 + 24,
  ee = 3 * 4 + 16,
  te = 2 * 4 + 12,
  ae = 4 + 16,
  re = 3 * 8 + 64,
  ie = 2 * 8 + 48,
  ge = 10 + 48,
  he = 3 * 6 + 40,
  le = 2 * 6 + 30,
  se = 6 + 32,
  ue = 3 * 6 + 24,
  oe = 2 * 6 + 18,
  ne = 6 + 24,
  me = 3 * 10 + 80,
  pe = 2 * 10 + 60,
  de = 12 + 56,
  ce = 3 * 8 + 48,
  Be = 2 * 8 + 36,
  Re = 8 + 40,
  fe = 3 * 8 + 32,
  xe = 2 * 8 + 24,
  Ce = 8 + 32,
  Me = 3 * 12 + 80,
  Oe = 2 * 12 + 60,
  we = 12 + 56,
  Le = 3 * 8 + 48,
  He = 2 * 8 + 36,
  ve = 8 + 40,
  Pe = 3 * 8 + 32,
  ke = 2 * 8 + 24,
  be = 8 + 32,
  d = [3, 3, 4, 5],
  C = 20,
  M = 16,
  O = 12,
  w = 28,
  L = 24,
  H = 24,
  v = 32,
  P = 28,
  k = 28,
  b = 36,
  V = 32,
  y = 32,
  e = {
    small: {
      height: {
        groupMultiplier: {
          normal: {
            smallRange: {
              fourBars: F,
              threeBars: J,
              twoBars: K
            },
            mediumRange: {
              fourBars: Q,
              threeBars: Y,
              twoBars: X
            },
            largeRange: {
              fourBars: ee,
              threeBars: te,
              twoBars: ae
            }
          },
          minusOne: {
            smallRange: {
              fourBars: C,
              threeBars: C,
              twoBars: C
            },
            mediumRange: {
              fourBars: M,
              threeBars: M,
              twoBars: M
            },
            largeRange: {
              fourBars: O,
              threeBars: O,
              twoBars: O
            }
          }
        },
        max: u.small.max
      },
      padding: {
        cutoff: d[0],
        group: {
          over: p,
          under: q
        },
        point: {
          over: s,
          under: s
        }
      },
      width: f.small
    },
    medium: {
      height: {
        groupMultiplier: {
          normal: {
            smallRange: {
              fourBars: re,
              threeBars: ie,
              twoBars: ge
            },
            mediumRange: {
              fourBars: he,
              threeBars: le,
              twoBars: se
            },
            largeRange: {
              fourBars: ue,
              threeBars: oe,
              twoBars: ne
            }
          },
          minusOne: {
            smallRange: {
              fourBars: w,
              threeBars: w,
              twoBars: w
            },
            mediumRange: {
              fourBars: L,
              threeBars: L,
              twoBars: L
            },
            largeRange: {
              fourBars: H,
              threeBars: H,
              twoBars: H
            }
          }
        },
        max: u.medium.max
      },
      padding: {
        cutoff: d[1],
        group: {
          over: p,
          under: x
        },
        point: {
          over: s,
          under: s
        }
      },
      width: f.medium
    },
    large: {
      height: {
        groupMultiplier: {
          normal: {
            smallRange: {
              fourBars: me,
              threeBars: pe,
              twoBars: de
            },
            mediumRange: {
              fourBars: ce,
              threeBars: Be,
              twoBars: Re
            },
            largeRange: {
              fourBars: fe,
              threeBars: xe,
              twoBars: Ce
            }
          },
          minusOne: {
            smallRange: {
              fourBars: v,
              threeBars: v,
              twoBars: v
            },
            mediumRange: {
              fourBars: P,
              threeBars: P,
              twoBars: P
            },
            largeRange: {
              fourBars: k,
              threeBars: k,
              twoBars: k
            }
          }
        },
        max: u.large.max
      },
      padding: {
        cutoff: d[2],
        group: {
          over: p,
          under: x
        },
        point: {
          over: s,
          under: s
        }
      },
      width: f.large
    },
    xLarge: {
      height: {
        groupMultiplier: {
          normal: {
            smallRange: {
              fourBars: Me,
              threeBars: Oe,
              twoBars: we
            },
            mediumRange: {
              fourBars: Le,
              threeBars: He,
              twoBars: ve
            },
            largeRange: {
              fourBars: Pe,
              threeBars: ke,
              twoBars: be
            }
          },
          minusOne: {
            smallRange: {
              fourBars: b,
              threeBars: b,
              twoBars: b
            },
            mediumRange: {
              fourBars: V,
              threeBars: V,
              twoBars: V
            },
            largeRange: {
              fourBars: y,
              threeBars: y,
              twoBars: y
            }
          }
        },
        max: u.xLarge.max
      },
      padding: {
        cutoff: d[3],
        group: {
          over: p,
          under: x
        },
        point: {
          over: s,
          under: s
        }
      }
    }
  },
  Ve = $(_templateObject || (_templateObject = _taggedTemplateLiteral([":is(.highcharts-column-series,.highcharts-bar-series) rect.highcharts-point{stroke:inherit}:host([stacking]) :is(.highcharts-column-series,.highcharts-bar-series) rect.highcharts-point{stroke:var(--beacon-chart-color-background)}:host([stacking]) :is(.highcharts-column-series,.highcharts-bar-series) rect.highcharts-point.highcharts-negative{stroke:var(--beacon-chart-highlight-area-color-fill)}.highcharts-point:hover{fill-opacity:100%}\n"])));
var ye = Object.defineProperty,
  Ne = Object.getOwnPropertyDescriptor,
  m = function m(h, a, t, r) {
    for (var i = r > 1 ? void 0 : r ? Ne(a, t) : a, l = h.length - 1, n; l >= 0; l--) (n = h[l]) && (i = (r ? n(a, t, i) : n(i)) || i);
    return r && i && ye(a, t, i), i;
  };
var o = /*#__PURE__*/function (_E) {
  _inherits(o, _E);
  function o() {
    var _this;
    _classCallCheck(this, o);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(o).apply(this, arguments)), _this.beaconTagName = c.beaconTagName, _this.variant = B.HORIZONTAL, _this.maxDataPoints = 12;
    return _this;
  }
  _createClass(o, [{
    key: "determinePaddingReturnValues",
    /**
     * Resolves the padding value based on the number of series and given type of padding. All charts will be forced into a stacked variant at 5+ series, so conditions only check for variations in bar amount before stacking is enabled.
     *
     * @param paddingType Group or Point padding
     * @param paddingValues Array of possible padding values based on the number of bars in the group, in order of 4, 3, 2
     * @returns {number} Padding value as number between 0 and 1
     */
    value: function determinePaddingReturnValues(a, t) {
      return this.seriesLength === 4 ? t[0] : this.seriesLength === 3 ? t[1] : this.seriesLength === 2 ? t[2] : a === g.GROUP ? R : W;
    }
    /**
     * Resolves the chart's height value based on the number of series. Charts are forced into a stacked variant at 5+ series, so conditions only check for variations in bar amount before stacking is enabled.
     *
     * @param heightValues Array of possible height values based on the numbers of bars, in order of 4, 3, 2
     * @returns The height value for the chart
     */
  }, {
    key: "determineHeightReturnValues",
    value: function determineHeightReturnValues(a) {
      if (this.seriesLength === 4) return a[0];
      if (this.seriesLength === 3) return a[1];
      if (this.seriesLength === 2) return a[2];
    }
    /**
     * Passes the available padding values to a separate function based on the total chart categories.
     *
     * @see determinePaddingReturnValues
     *
     * @param paddingType Group or Point padding
     * @param cutoffAmount The number of groups used to divide the values between groups less than cutoff and groups at cutoff and above
     * @param overCutoffValues Possible values if over the cutoff
     * @param underCutoffValues Possible values if under the cutoff
     * @returns The padding value based on the amount of categories in the chart
     */
  }, {
    key: "determineCategoryCutoffRoute",
    value: function determineCategoryCutoffRoute(a, t, r, i) {
      return this.totalChartCategories ? this.totalChartCategories >= t ? this.determinePaddingReturnValues(a, r) : this.determinePaddingReturnValues(a, i) : !1;
    }
    /**
     * Passes the available height values to a separate function based on total chart categories
     *
     * @see determineHeightReturnValues
     *
     * @param smallValues Possible values in the small range
     * @param mediumValues Possible values in the medium range
     * @param largeValues Possible values in the large range
     */
  }, {
    key: "determineHeightCutoffRoute",
    value: function determineHeightCutoffRoute(a, t, r) {
      if (this.totalChartCategories) return this.totalChartCategories <= u.small.end ? this.determineHeightReturnValues(a) : this.totalChartCategories >= u.medium.start && this.totalChartCategories <= u.medium.end ? this.determineHeightReturnValues(t) : this.determineHeightReturnValues(r);
    } /** All possible group padding values based on small, medium, large, or xLarge charts. */
  }, {
    key: "calculatePadding",
    /**
     * Gets the padding value of a given type based on the width of the chart.
     *
     * @param paddingType Can be group or point padding
     * @returns The resulting padding value in x axis units
     */
    value: function calculatePadding() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : g.POINT;
      var t = a === g.GROUP;
      return t && this.validatedStacking ? R : !this.totalChartCategories || !this.componentWidth || !this.seriesLength ? t ? R : W : this.componentWidth <= e.small.width ? t ? this.groupPaddingValues.small : this.pointPaddingValues.small : this.componentWidth > e.small.width && this.componentWidth <= e.medium.width ? t ? this.groupPaddingValues.medium : this.pointPaddingValues.medium : this.componentWidth > e.medium.width && this.componentWidth <= e.large.width ? t ? this.groupPaddingValues.large : this.pointPaddingValues.large : t ? this.groupPaddingValues.xLarge : this.pointPaddingValues.xLarge;
    }
    /**
     * Calculates the height a chart should be at given its categories, number of series, and the width of the chart.
     *
     * @param normalMultiplier Number to mulitply the total group count by
     * @param minusOneMultiplier Number to multiply (total group count - 1) by
     * @returns A height in pixels
     */
  }, {
    key: "calculateChartHeight",
    value: function calculateChartHeight(a, t, r) {
      var i, l;
      if (!((i = this.chartSize) != null && i.chartHeight) || !((l = this.chartSize) != null && l.plotHeight) || !this.totalChartCategories) return;
      var _this$chartSize = this.chartSize,
        n = _this$chartSize.chartHeight,
        G = _this$chartSize.plotHeight,
        S = n - G,
        T = this.totalChartCategories * a + (this.totalChartCategories - 1) * t,
        D = T > r ? r : T;
      return S + D;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var a;
      (a = this.handleDefer()) == null || a.then(function () {
        _get(_getPrototypeOf(o.prototype), "connectedCallback", _this2).call(_this2);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return z(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<div class=\"chart-and-tooltip-wrapper\">", "\n    <", " id=", " orientation=", "></", "></div>"])), _get(_getPrototypeOf(o.prototype), "render", this).call(this), this.getScopedTag("beacon-chart-tooltip"), c.tooltipID, this.variant, this.getScopedTag("beacon-chart-tooltip"));
    }
  }, {
    key: "type",
    /** The type of chart being rendered. */get: function get() {
      return this.variant === B.HORIZONTAL ? I.BAR : I.COLUMN;
    } /** Determine if the total number of series exceeds the max allowed before stacking needs turned on. */
  }, {
    key: "chartExceedsMaxUnstacked",
    get: function get() {
      return this.seriesLength ? this.seriesLength >= _ : !1;
    } /** If there are more series than the max allowed before stacking, force stacking to be turned on at a default. */
  }, {
    key: "validatedStacking",
    get: function get() {
      return this.chartExceedsMaxUnstacked ? (this.setAttribute(c.stackingAttribute, this.stacking ? this.stacking : N.NORMAL), this.stacking ? this.stacking : N.NORMAL) : this.stacking;
    } /** Options specific to the Bar chart. */
  }, {
    key: "localComponentOptions",
    get: function get() {
      var a = this.figure,
        t = this.tooltipRef;
      return {
        chart: {
          height: this.height
        },
        plotOptions: {
          series: {
            groupPadding: this.calculatePadding(g.GROUP),
            pointPadding: this.calculatePadding(),
            stacking: this.validatedStacking,
            point: {
              events: {
                mouseOver: function mouseOver() {
                  if (!t) return;
                  var r = this,
                    i = r.graphic.element.getBoundingClientRect(),
                    l = r.index;
                  t.tooltipData = [{
                    label: r.series.name,
                    value: r.series.yData[l],
                    index: r.colorIndex
                  }], t.targetRect = i, t.viewportRect = a.getBoundingClientRect(), t.open();
                },
                mouseOut: function mouseOut() {
                  t == null || t.close();
                }
              }
            }
          }
        }
      };
    } /** Size of the plotbox (not including axes). */
  }, {
    key: "componentWidth",
    get: function get() {
      var a;
      return (a = this.chartSize) == null ? void 0 : a.plotWidth;
    }
  }, {
    key: "groupPaddingValues",
    get: function get() {
      return {
        small: this.determineCategoryCutoffRoute(g.GROUP, e.small.padding.cutoff, e.small.padding.group.over, e.small.padding.group.under),
        medium: this.determineCategoryCutoffRoute(g.GROUP, e.medium.padding.cutoff, e.medium.padding.group.over, e.medium.padding.group.under),
        large: this.determineCategoryCutoffRoute(g.GROUP, e.large.padding.cutoff, e.large.padding.group.over, e.large.padding.group.under),
        xLarge: this.determineCategoryCutoffRoute(g.GROUP, e.xLarge.padding.cutoff, e.xLarge.padding.group.over, e.xLarge.padding.group.under)
      };
    } /** All possible point padding values based on small, medium, large, or xLarge charts. */
  }, {
    key: "pointPaddingValues",
    get: function get() {
      return {
        small: this.determineCategoryCutoffRoute(g.POINT, e.small.padding.cutoff, e.small.padding.point.over, e.small.padding.point.under),
        medium: this.determineCategoryCutoffRoute(g.POINT, e.medium.padding.cutoff, e.medium.padding.point.over, e.medium.padding.point.under),
        large: this.determineCategoryCutoffRoute(g.POINT, e.large.padding.cutoff, e.large.padding.point.over, e.large.padding.point.under),
        xLarge: this.determineCategoryCutoffRoute(g.POINT, e.xLarge.padding.cutoff, e.xLarge.padding.point.over, e.xLarge.padding.point.under)
      };
    } /** Collection of heights based on small, medium, large, or xLarge charts. */
  }, {
    key: "chartHeightValues",
    get: function get() {
      if (this.variant !== B.VERTICAL) return {
        small: this.determineHeightCutoffRoute([this.calculateChartHeight(e.small.height.groupMultiplier.normal.smallRange.fourBars, e.small.height.groupMultiplier.minusOne.smallRange.fourBars, e.small.height.max), this.calculateChartHeight(e.small.height.groupMultiplier.normal.smallRange.threeBars, e.small.height.groupMultiplier.minusOne.smallRange.threeBars, e.small.height.max), this.calculateChartHeight(e.small.height.groupMultiplier.normal.smallRange.twoBars, e.small.height.groupMultiplier.minusOne.smallRange.twoBars, e.small.height.max)], [this.calculateChartHeight(e.small.height.groupMultiplier.normal.mediumRange.fourBars, e.small.height.groupMultiplier.minusOne.mediumRange.fourBars, e.small.height.max), this.calculateChartHeight(e.small.height.groupMultiplier.normal.mediumRange.threeBars, e.small.height.groupMultiplier.minusOne.mediumRange.threeBars, e.small.height.max), this.calculateChartHeight(e.small.height.groupMultiplier.normal.mediumRange.twoBars, e.small.height.groupMultiplier.minusOne.mediumRange.twoBars, e.small.height.max)], [this.calculateChartHeight(e.small.height.groupMultiplier.normal.largeRange.fourBars, e.small.height.groupMultiplier.minusOne.largeRange.fourBars, e.small.height.max), this.calculateChartHeight(e.small.height.groupMultiplier.normal.largeRange.threeBars, e.small.height.groupMultiplier.minusOne.largeRange.threeBars, e.small.height.max), this.calculateChartHeight(e.small.height.groupMultiplier.normal.largeRange.twoBars, e.small.height.groupMultiplier.minusOne.largeRange.twoBars, e.small.height.max)]),
        medium: this.determineHeightCutoffRoute([this.calculateChartHeight(e.medium.height.groupMultiplier.normal.smallRange.fourBars, e.medium.height.groupMultiplier.minusOne.smallRange.fourBars, e.medium.height.max), this.calculateChartHeight(e.medium.height.groupMultiplier.normal.smallRange.threeBars, e.medium.height.groupMultiplier.minusOne.smallRange.threeBars, e.medium.height.max), this.calculateChartHeight(e.medium.height.groupMultiplier.normal.smallRange.twoBars, e.medium.height.groupMultiplier.minusOne.smallRange.twoBars, e.medium.height.max)], [this.calculateChartHeight(e.medium.height.groupMultiplier.normal.mediumRange.fourBars, e.medium.height.groupMultiplier.minusOne.mediumRange.fourBars, e.medium.height.max), this.calculateChartHeight(e.medium.height.groupMultiplier.normal.mediumRange.threeBars, e.medium.height.groupMultiplier.minusOne.mediumRange.threeBars, e.medium.height.max), this.calculateChartHeight(e.medium.height.groupMultiplier.normal.mediumRange.twoBars, e.medium.height.groupMultiplier.minusOne.mediumRange.twoBars, e.medium.height.max)], [this.calculateChartHeight(e.medium.height.groupMultiplier.normal.largeRange.fourBars, e.medium.height.groupMultiplier.minusOne.largeRange.fourBars, e.medium.height.max), this.calculateChartHeight(e.medium.height.groupMultiplier.normal.largeRange.threeBars, e.medium.height.groupMultiplier.minusOne.largeRange.threeBars, e.medium.height.max), this.calculateChartHeight(e.medium.height.groupMultiplier.normal.largeRange.twoBars, e.medium.height.groupMultiplier.minusOne.largeRange.twoBars, e.medium.height.max)]),
        large: this.determineHeightCutoffRoute([this.calculateChartHeight(e.large.height.groupMultiplier.normal.smallRange.fourBars, e.large.height.groupMultiplier.minusOne.smallRange.fourBars, e.large.height.max), this.calculateChartHeight(e.large.height.groupMultiplier.normal.smallRange.threeBars, e.large.height.groupMultiplier.minusOne.smallRange.threeBars, e.large.height.max), this.calculateChartHeight(e.large.height.groupMultiplier.normal.smallRange.twoBars, e.large.height.groupMultiplier.minusOne.smallRange.twoBars, e.large.height.max)], [this.calculateChartHeight(e.large.height.groupMultiplier.normal.mediumRange.fourBars, e.large.height.groupMultiplier.minusOne.mediumRange.fourBars, e.large.height.max), this.calculateChartHeight(e.large.height.groupMultiplier.normal.mediumRange.threeBars, e.large.height.groupMultiplier.minusOne.mediumRange.threeBars, e.large.height.max), this.calculateChartHeight(e.large.height.groupMultiplier.normal.mediumRange.twoBars, e.large.height.groupMultiplier.minusOne.mediumRange.twoBars, e.large.height.max)], [this.calculateChartHeight(e.large.height.groupMultiplier.normal.largeRange.fourBars, e.large.height.groupMultiplier.minusOne.largeRange.fourBars, e.large.height.max), this.calculateChartHeight(e.large.height.groupMultiplier.normal.largeRange.threeBars, e.large.height.groupMultiplier.minusOne.largeRange.threeBars, e.large.height.max), this.calculateChartHeight(e.large.height.groupMultiplier.normal.largeRange.twoBars, e.large.height.groupMultiplier.minusOne.largeRange.twoBars, e.large.height.max)]),
        xLarge: this.determineHeightCutoffRoute([this.calculateChartHeight(e.xLarge.height.groupMultiplier.normal.smallRange.fourBars, e.xLarge.height.groupMultiplier.minusOne.smallRange.fourBars, e.xLarge.height.max), this.calculateChartHeight(e.xLarge.height.groupMultiplier.normal.smallRange.threeBars, e.xLarge.height.groupMultiplier.minusOne.smallRange.threeBars, e.xLarge.height.max), this.calculateChartHeight(e.xLarge.height.groupMultiplier.normal.smallRange.twoBars, e.xLarge.height.groupMultiplier.minusOne.smallRange.twoBars, e.xLarge.height.max)], [this.calculateChartHeight(e.xLarge.height.groupMultiplier.normal.mediumRange.fourBars, e.xLarge.height.groupMultiplier.minusOne.mediumRange.fourBars, e.xLarge.height.max), this.calculateChartHeight(e.xLarge.height.groupMultiplier.normal.mediumRange.threeBars, e.xLarge.height.groupMultiplier.minusOne.mediumRange.threeBars, e.xLarge.height.max), this.calculateChartHeight(e.xLarge.height.groupMultiplier.normal.mediumRange.twoBars, e.xLarge.height.groupMultiplier.minusOne.mediumRange.twoBars, e.xLarge.height.max)], [this.calculateChartHeight(e.xLarge.height.groupMultiplier.normal.largeRange.fourBars, e.xLarge.height.groupMultiplier.minusOne.largeRange.fourBars, e.xLarge.height.max), this.calculateChartHeight(e.xLarge.height.groupMultiplier.normal.largeRange.threeBars, e.xLarge.height.groupMultiplier.minusOne.largeRange.threeBars, e.xLarge.height.max), this.calculateChartHeight(e.xLarge.height.groupMultiplier.normal.largeRange.twoBars, e.xLarge.height.groupMultiplier.minusOne.largeRange.twoBars, e.xLarge.height.max)])
      };
    } /** The height of the chart. */
  }, {
    key: "height",
    get: function get() {
      var a, t, r, i;
      if (!(this.validatedStacking || !this.totalChartCategories || !this.seriesLength || !this.componentWidth)) return this.componentWidth <= e.small.width ? (a = this.chartHeightValues) == null ? void 0 : a.small : this.componentWidth > e.small.width && this.componentWidth <= e.medium.width ? (t = this.chartHeightValues) == null ? void 0 : t.medium : this.componentWidth > e.medium.width && this.componentWidth <= e.large.width ? (r = this.chartHeightValues) == null ? void 0 : r.large : (i = this.chartHeightValues) == null ? void 0 : i.xLarge;
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(o), "styles", this), Ve];
    }
  }]);
  return o;
}(E(Z));
o.tagName = c.beaconTagName;
m([U()], o.prototype, "variant", 2);
m([U()], o.prototype, "stacking", 2);
m([j()], o.prototype, "maxDataPoints", 2);
m([A("#chart-custom-tooltip")], o.prototype, "tooltipRef", 2);
m([A("figure.base")], o.prototype, "figure", 2);
export { o as BeaconBarChart };